/**
 * C-06: варианты длительности mute. Верхняя граница — год: BS §17.8
 * задаёт `muted_until ≤ +1 год | null`, поэтому «пока не включу» и есть год.
 * Общий список для меню диалога и меню строки в списке чатов.
 */
export const MUTE_OPTIONS: readonly { label: string; ms: number }[] = [
  { label: 'На час', ms: 60 * 60_000 },
  { label: 'На 8 часов', ms: 8 * 60 * 60_000 },
  { label: 'На неделю', ms: 7 * 24 * 60 * 60_000 },
  { label: 'Пока не включу (год)', ms: 365 * 24 * 60 * 60_000 },
]
